import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TranslateService } from '@ngx-translate/core';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { GoogleMapsLoaderService } from './shared/services/maps/google-maps-loader.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'ResilientGalicia';

  constructor(
    private primengConfig: PrimeNGConfig,
    private translate: TranslateService,
    private googleMapsLoader: GoogleMapsLoaderService
  ) {}

  ngOnInit(): void {
    this.googleMapsLoader.loadGoogleMaps().catch((error) => {
      console.error('Error loading Google Maps:', error);
    });
    this.primengConfig.ripple = false;
    this.translate.stream(['primeng']).subscribe((translations: any) => {
      this.primengConfig.setTranslation(translations['primeng']);
    });
    AOS.init();
    
  }
}
